module.exports = __webpack_public_path__ + "img/img-how-work.a509aebd.svg";